// extracted by mini-css-extract-plugin
export default {"close_button":"NotificationCloseButton_close_button__vTdUB","shimmer":"NotificationCloseButton_shimmer__Fid54"};